import Component from './Component'

export default class Group extends Component {

	static _type = 'Group'

	form			// Parent form component

	input_el		// DOM Elements
	feedback_el

	_field_listeners = {}

	tether () {
		super.tether()

		// Own DOM elements
		this.input_el = this.base.querySelector(`#${this.id}-dummy`)
		this.feedback_el = this.base.querySelector(`#${this.id}-invalid-feedback`)

		// Enclosing form
		this.form = this.base.closest('form[anvil-component]').anvil
		//this.form.registerInput(this.params.name, this)

		// Grab a list of all fields we need to watch
		for (let field of this.params.fields) {
			if ('name' in field && !(field.name in this._field_listeners)) {
				// Create listener and register
				this._field_listeners[field.name] = Group._updateListener.bind({ that: this, name: field.name })
				this.form.data.record.on(field.name + '-updated', this._field_listeners[field.name])	// node event
			}
		}
	}

	static _updateListener (value, errors) {

		// Render validation
		this.that.renderValidation()

		// Update hook
		if ('update' in this.that.params && typeof this.that.params.update == 'function') {
			this.that.params.update(null, this.name, this.that.form.data, this.that.params)
		}
	}

	renderValidation () {

		// Get all the relevant field errors
		let errors = []
		for (let data_field of Object.keys(this._field_listeners)) {
			// Find a title if there is one
			let field = this.params.fields.find(x => x.name == data_field && x.title !== undefined)

			let field_errors = this.form.data.record.getErrors(data_field)
			if (field_errors !== null) {
				if (field !== undefined) {
					// There is a title
					for (let field_error of field_errors) {
						errors.push(`<strong>${field.title}:</strong> ${field_error}`)
					}
				} else {
					// No title
					errors.push(...field_errors)
				}
			}
		}

		if (errors.length == 0) {
			// Validation successful
			$(this.input_el).removeClass('is-invalid')
			$(this.feedback_el).html('')
		} else {
			// Invalid
			$(this.input_el).addClass('is-invalid')
			$(this.feedback_el).html(errors.join('<br />'))
		}
	}

	destroy () {

		// Unregister event handlers
		for (let data_field of Object.keys(this._field_listeners)) {
			this.form.data.record.off(data_field + '-updated', this._field_listeners[data_field])
			this._field_listeners[data_field] = null
		}

		delete this.input_el
		delete this.feedback_el
		delete this.form

		super.destroy()
	}
}
